import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { connectedAccountsSelector } from "./connectedAccountsSelector";
import { accountsGroupedByProviderCombiner } from "../../combiners/accountsGroupedByProviderCombiner";

export const connectedAccountsGroupedByProviderSelector =
  createDraftSafeSelector(
    [connectedAccountsSelector],
    accountsGroupedByProviderCombiner,
  );
